import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
// import { FileUploadModule } from 'ng2-file-upload';
import { ToastrModule } from 'ngx-toastr';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ImageCropperModule } from 'ngx-image-cropper';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { OwlMomentDateTimeModule } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time.module';
// import { OwlMomentDateTimeModule } from 'ng-pick-datetime-moment';
// directives
import { OnlyNumberDirective } from './directives/only-number.directive';
// guards
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';

//----------------Material----------------//
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperIntl, MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatTreeModule } from '@angular/material/tree';
// services
import { LoginService } from './services/login.service';
import { RolesService } from './services/roles.service';
import { AuthService } from './services/auth.service';
import { ValidationService } from './services/validation.service';
import { ExcelService } from './services/excel.service';
import { ObjectService } from './services/object.service';
import { SettingService } from './services/setting.service';
import { InterceptorService } from './services/interceptor.service';
import { EmployeesService } from './services/employees.service';
import { StorageService } from './services/storage.service';
import { LocalService } from './services/local.service';
// Commmon components
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { DashboardSidenavComponent } from './components/dashboard-sidenav/dashboard-sidenav.component';
import { LoadingComponent } from './components/loading/loading.component';
import { InprogressComponent } from './components/inprogress/inprogress.component';
import { UserPermissionTabComponent } from './components/user-permission-tab/user-permission-tab.component';
import { ItemPerPageFilterComponent } from './components/item-per-page-filter/item-per-page-filter.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { TransporterAccountComponent } from './components/transporter-account/transporter-account.component';

export const MY_MOMENT_FORMATS = {
  parseInput: 'l LT',
  fullPickerInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

import { DatePipe } from '@angular/common'
import { ThankDialogComponent } from './components/thank-dialog/thank-dialog.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    DashboardSidenavComponent,
    LoadingComponent,
    InprogressComponent,
    UserPermissionTabComponent,
    OnlyNumberDirective,
    ItemPerPageFilterComponent,
    ConfirmDialogComponent,
    TransporterAccountComponent,
    ThankDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ImageCropperModule,
    RouterModule,
    HttpClientModule,
    NgbModule,
    NgSelectModule,
    // FileUploadModule,
    ToastrModule.forRoot(),
    NgxPaginationModule,
    OwlDateTimeModule, 
    OwlMomentDateTimeModule,
    //----------------Material----------------//
    MatAutocompleteModule, MatButtonModule, MatButtonToggleModule,
    MatCardModule, MatCheckboxModule, MatChipsModule, MatStepperModule, MatDatepickerModule,
    MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule,
    MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule,
    MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule,
    MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule,
    MatTabsModule, MatToolbarModule, MatTooltipModule, MatBottomSheetModule, MatFormFieldModule, MatTreeModule
    //----------------Material----------------//
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    DashboardSidenavComponent,
    LoadingComponent,
    NgbModule,
    NgSelectModule,
    // FileUploadModule,
    FormsModule,
    ReactiveFormsModule,
    ImageCropperModule,
    NgxPaginationModule,
    OwlDateTimeModule, 
    OwlMomentDateTimeModule,
    //----------------Material----------------//
    MatAutocompleteModule, MatButtonModule, MatButtonToggleModule,
    MatCardModule, MatCheckboxModule, MatChipsModule, MatStepperModule, MatDatepickerModule,
    MatDialogModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule,
    MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule,
    MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule,
    MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule,
    MatTabsModule, MatToolbarModule, MatTooltipModule, MatBottomSheetModule, MatFormFieldModule, MatTreeModule,
    //----------------Material----------------//
    UserPermissionTabComponent,
    OnlyNumberDirective,
    ItemPerPageFilterComponent,
    TransporterAccountComponent
  ],
  entryComponents: [
    ConfirmDialogComponent,
    ThankDialogComponent
  ]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        AuthGuard,
        RoleGuard,
        LoginService,
        RolesService,
        AuthService,
        ValidationService,
        ExcelService,
        ObjectService,
        SettingService,
        EmployeesService,
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
        StorageService,
        LocalService,
        DatePipe
      ]
    }
  }
}
